<template>
  <div id="review">
    <div>
      <div class="add radio" v-if="secondMember">
        <!--<span>当前身份：
          <span :class="{'active': (activeMember.id == currentMember.id)}" @click="changeType(currentMember)">{{currentMember.name}}</span>
          <span :class="{'active': (activeMember.id == secondMember.id)}" @click="changeType(secondMember)">{{secondMember.name}}</span>
        </span>-->
        <span>当前身份</span>
        <div class="checkbox" >
          <van-checkbox :value="activeMember.id == currentMember.id" @click="changeType(currentMember)" >{{ currentMember.name }}</van-checkbox>
          <van-checkbox :value="activeMember.id == secondMember.id" @click="changeType(secondMember)" >{{ secondMember.name }}</van-checkbox>
        </div>
      </div>
      <div class="add" v-if="applyMember.length>0">
        <span>当前身份：{{currentMember.name}}
        <br/>
          还可申请：<span class="line" @click="applyMemberAction(applyMember[0])">{{applyMember[0].name}}</span>
          <span class="line"  v-if="applyMember.length>1" @click="applyMemberAction(applyMember[1])">{{applyMember[1].name}}</span>
        </span>
      </div>
      <!-- 待审核 -->
      <div v-show="activeMember.status == 0"> <!-- 0 -->
        <div class="add word">
          <img src="@/assets/images/Group.png">
          <span>您的申请已提交</span>
        </div>
        <div class="message" >
<!--          <p>我们将在48小时内处理并已短信通知形式通知到您，请注意查收！</p>-->
          <p>审核时间约需要两个工作日，遇休息日、节假日顺延。</p><p>审核结果将以短信通知形式通知到您，请注意查收！</p>

        </div>
        <van-button class="btn" size="large" @click="routerGo()" >返回协会官网</van-button>
      </div>
      <!-- 未通过 -->
      <div v-show="activeMember.status == 1"> <!-- 1 -->
        <div class="add word refuse">
          <img src="@/assets/images/refuse.png">
        </div>
        <div class="message" >
          <p>拒绝原因：{{currentMember && currentMember.remark}}</p>
        </div>
        <div style="width: 100%; height: 80px;" ></div>
        <van-button class="btn" size="large" @click="updateInfo()" >完善资料重新审核</van-button>
        <a class="back" size="large" @click="routerGo()" >返回协会官网</a>
        </div>
        <!-- 已通过 且不重置 -->
      <div v-show="activeMember.status == 2 && activeMember.reset != 1">  <!-- 2 -->
        <div class="add word refuse">
          <img src="@/assets/images/pass-through.png">
        </div>
        <div class="message">
          <p>您需要支付相应会员费用，以便正常启用会员功能</p>
        </div>
        <div style="width: 100%; height: 80px;" ></div>
        <van-button class="btn" size="large" @click="payFor()" >去付款</van-button>
        <a class="back" size="large" @click="routerGo()" >返回协会官网</a>
      </div>
      <!-- 已通过 且已重置 -->
      <div v-show="activeMember.status == 2 && activeMember.reset == 1">  <!-- 2 -->
        <div class="add word">
          <img src="@/assets/images/Group.png">
        </div>
        <div class="message">
          <p>已开启注册阶段，请更新相关信息完成提交</p>
        </div>
        <div style="width: 100%; height: 80px;" ></div>
        <van-button class="btn" size="large" @click="goNextYearRegister()" >去注册</van-button>
        <a class="back" size="large" @click="routerGo()" >返回协会官网</a>
      </div>
      <!-- 冻结 -->
      <div v-show="activeMember.status == -1">
        <div class="add word refuse">
          <img src="@/assets/images/freeze.png">
        </div>
        <div class="message" >
          <p>冻结原因: 有可能您的操作违规,请联系协会处理</p>
          <p>联系电话：010-88367411</p>

        </div>
        <div style="width: 100%; height: 80px;" ></div>
        <van-button class="btn" size="large" @click="routerGo()" >返回官网</van-button>
      </div>

      <div class="footer">
        <p v-if="false">北京冰球运动协会{{validMemberShip.year}}年度协会会员</p>
        <p v-if="false">有效期至：{{endDate}}</p>
        <a class="back" style="padding-bottom: 0;" size="large" @click="changePhone()" >换绑手机</a>
        <a class="back" size="large" @click="logOut()" >退出登录</a>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import _ from 'lodash'
import * as moment from 'moment'
import { checkPassport } from '@/libs/passport'
import { getValidMembership, mapMemberType } from '@/utils'
import { getUserInfo, setMemberType, removeOpenId, removeMembership, removeUserInfo,
  removeRegisterInfo, removeToken, getMemberType, removeMemberType, setMembership } from '@/libs/cookie-storage'
import { getMyMembershipStatus, updateMembershipStatus } from '@/api/info'
import { logOut } from '@/api/user'

import { Icon, Button, Toast } from 'vant'

Vue.use(Icon).use(Button)

export default {
  name: 'Review',
  data() {
    return {
      currentMember: null,
      secondMember: null,
      applyMember: [],
      activeMember: {},
      validMemberShip: {},
      endDate: '',
      reset: 0
    }
  },
  created () {
    this.reset = this.$route.query.reset
    checkPassport()
    getMyMembershipStatus().then((response) => {
      if (!response) return
      const validMemberShip = this.validMemberShip = getValidMembership(response.data)
      setMembership(response.data)
      if(this.validMemberShip) {
        this.endDate = moment(this.validMemberShip.membershipEndDate).format('YYYY年MM月DD日')
      }
      const membership = validMemberShip.membership
      if (membership.length === 0) {
        this.$router.push('evpi')
        return
      }
      // TODO pay status check
      const memberType = getMemberType()
      let member = null
      member = _.find(membership, function (item) {
        // return item.paymentStatus < 1 || (!item.insurance) // 付款未通过 payStatus
        return item.paymentStatus < 1 // // 教练员没有保险费，该逻辑去掉
      })
      if (memberType) {
        const tmpMember = _.find(membership, function (item) {
          return item.membershipTypeId === memberType.membershipTypeId // 根据上一个页面获取
        })
        if (tmpMember && tmpMember.paymentStatus < 1) {
          member = tmpMember
        } else {
          removeMemberType()
        }
      }

      if (member) { // 如果有一个身份未付款，进入等待审核页面
        const currentMember = mapMemberType(member.membershipTypeId)
        this.currentMember = _.assign(currentMember, member) // 字段合并
        if (membership.length > 1) {
          let sec = membership[1]
          if(sec.membershipTypeId == member.membershipTypeId) {
            sec = membership[0]
          }
          let secondMember = mapMemberType(sec.membershipTypeId)
          this.secondMember = _.assign(secondMember, sec) // 字段合并
        } else {
          if (currentMember.id === 1) { // 运动员
            if (this.validMemberShip.coachRegisterEnabled) {
              // this.applyMember.push(mapMemberType(2))
              if (this.validMemberShip.inRefereeRegisterEnabled) {
                this.applyMember.push(mapMemberType(3))
              }
              if (this.validMemberShip.outRefereeRegisterEnabled) {
                this.applyMember.push(mapMemberType(4))
              }
            }
          } else if (currentMember.id === 2) { // 教练员
            if (this.validMemberShip.inRefereeRegisterEnabled) {
              this.applyMember.push(mapMemberType(3))
            }
            if (this.validMemberShip.outRefereeRegisterEnabled) {
              this.applyMember.push(mapMemberType(4))
            }
          } else if (currentMember.id === 3 || currentMember.id === 4) { // 裁判
            if (this.validMemberShip.coachRegisterEnabled) {
              this.applyMember.push(mapMemberType(2))
            }
          }
        }
        this.activeMember = currentMember
        // this.activeMember.reset = 1
        if (this.reset === 2) {
          this.activeMember.reset = 2
        }
      } else {
         this.$router.push('ucenter')
      }
    })
  },
  mounted () {},
  methods: {
    routerGo() {
      window.location.href = 'http://www.bjhockey.org'
    },
    updateInfo() {
      setMemberType(this.activeMember)
      // this.$router.push({path: 'info', query: {edit: 1} }) // TODO 编辑信息，重新提交
      this.$router.push('info')
    },
    goNextYearRegister() {
      // this.$router.push({ path: 'account-protocol', query: {id: 1, reset: 1} })
      const mode = this.$route.query.mode
     if (mode === 'test' ||
       (this.activeMember.membershipTypeId === 1 && this.validMemberShip.playerRegisterEnabled === 1) ||
       (this.activeMember.membershipTypeId === 2 && this.validMemberShip.coachRegisterEnabled === 1) ||
       (this.activeMember.membershipTypeId === 3 && this.validMemberShip.inRefereeRegisterEnabled === 1) ||
       (this.activeMember.membershipTypeId === 4 && this.validMemberShip.outRefereeRegisterEnabled === 1) ||
       (this.activeMember.membershipTypeId === 0 && this.validMemberShip.orgRegisterEnabled === 1)) {
       setMemberType(this.activeMember)
       // this.$router.push({path: 'info', query: {reset: 1} })
       this.$router.push({ path: 'account-protocol', query: {id: 1, reset: 1} })
     } else {
       Toast('当前身份未开放注册，请关注协会开放具体注册时间的通知')
     }
    },
    payFor() {
      this.$router.push({ path: 'order', query: {type: this.activeMember.membershipTypeId} })
      /*
      if (this.activeMember.id == 0 || this.activeMember.id == 2) {
        this.$router.push({ path: 'order', query: {type: this.activeMember.id} })
      } else {
        this.$router.push({ path: 'identity-protocol', query: {id: 3, type: this.activeMember.id} })
      } */
    },
    changeType(member) {
      if (member.paymentStatus > 0 && member.status > 0) {
        setMemberType(member.membershipTypeId)
        this.$router.push('ucenter')
        return
      }
      this.activeMember = member
    },
    applyMemberAction(member) {
      setMemberType(member)
      this.$router.push('info')
    },
    removeWechat() {
      removeOpenId()
    },
    logOut() {
      logOut().then(res => {
        if (res) {
          const data = res.data
          if (data) {
            Toast('退出登录')
            removeMembership()
            removeUserInfo()
            removeToken()
            removeOpenId()
            removeRegisterInfo()
            removeMemberType()
            this.$router.push('login')
          }
        }
      })
    },
    changePhone () {
      this.$router.push('replace-phone')
    }
  },
  computed: {}
}
</script>
<style>
#review {
  height: 100%;
  background-color: white;
  padding: 15px;
}

#review .add {
  display: flex;
  align-items: center;
  justify-items: right;
  font-size: 16px; /*no*/
  color: #818181;
}

#review .add .active {
  color: red;
}

#review .icon {
  font-size: 30px;
  color: #a9b7b7;
}

#review .word span {
  font-size:20px;
  font-weight:500;
  color:rgba(24,84,148,1);
  margin-top: 15px;
}

#review .word {
  margin-top: 100px;
  justify-content: center;
  flex-direction: column;
}

#review .word img {
  width: 72px;
  height: 60px;
}

#review .message {
  margin-top: 10px;
  font-size: 14px;
  text-align: center;
}

#review .message p {
  font-size:14px;
  line-height: 1.5;
  margin: 0;
  font-weight:400;
  color:rgba(24,84,148,1);
}

#review .btn {
  height:60px;
  background: #185494;
  border-radius:2px;
  border: none;
  margin-top: 30px;
  font-weight:400;
  color: white;
  font-size:20px;
}

#review .refuse {
  margin-top: 20px;
}

#review .refuse img {
  width: 100%;
  height: auto;
}

#review .back {
  font-weight:400;
  color:rgba(24,84,148,1);
  font-size:16px;
  text-align: center;
  display: block;
  padding: 15px 0;
}

#review .radio {
  display: flex;
  padding: 3px 0
}

#review .radio {
  justify-content: space-between;
}

#review .radio .checkbox {
  display: flex;
}

#review .radio .checkbox .van-checkbox:first-child {
  margin-right: 10px;
}

#review .radio .checkbox .van-checkbox .van-radio__label {
  margin-left: 2px;
}

#review .footer {
  margin-top: 15px;
}

#review .footer p {
  color: #185494;
  line-height: 1.4;
  margin: 0;
  font-size:14px;
  font-weight:400;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/review.vue